import React from "react";
import { generatePath } from "react-router-dom";
import NavigationTabs, {
  NavigationTabDefinition,
} from "../components/NavigationTabs";
import { useParams } from "../util";
import EnvironmentListPage from "./EnvironmentListPage";
import ServiceListPage from "./ServiceListPage";
import DomainsPage from "./DomainsPage";
import { useResource } from "../useResource";
import API from "../api";
import DeploymentsPage from "./DeploymentsPage";
import { ProjectSettingsPage } from "./ProjectSettingsPage";

export const projectPagePath = "/projects/:project_name/:tab?";

export default function ProjectPage() {
  const { project_name, tab } = useParams(projectPagePath);
  const [project] = useResource(API.projects.read, project_name);

  const tabs: NavigationTabDefinition[] = [
    {
      id: "services",
      label: "Services",
      page: <ServiceListPage projectName={project_name} />,
    },
    {
      id: "environments",
      label: "Environments",
      page: <EnvironmentListPage projectName={project_name} />,
    },
    {
      id: "domains",
      label: "Domains",
      page: <DomainsPage project={project} />,
    },
    {
      id: "deployments",
      label: "Deployments",
      page: <DeploymentsPage project={project} />,
    },
    {
      id: "info",
      label: "Settings",
      page: <ProjectSettingsPage project={project} />,
    },
  ];

  return (
    <NavigationTabs
      basePath={generatePath(projectPagePath, {
        project_name,
      })}
      tabs={tabs}
      currentTabID={tab}
    />
  );
}
